import {
  createMaterialApi,
  patchMaterialApi,
  deleteMaterialApi,
  getMaterialApi,
  listMaterialsApi,
} from './apiClient'
import type { Material, MaterialInput } from './types'

export const materialService = {
  /** Phase 3: Postgres via /api (Vite proxy injects X-Api-Token). */
  list(): Promise<Material[]> {
    return listMaterialsApi()
  },
  getById(id: string): Promise<Material | null> {
    return getMaterialApi(id)
  },
  create(input: MaterialInput): Promise<Material> {
    return createMaterialApi(input)
  },
  patch(
    id: string,
    patch: Partial<MaterialInput> & {
      group_code?: string | null
      attributes?: Record<string, any>
    },
  ): Promise<Material> {
    return patchMaterialApi(id, patch)
  },
  remove(id: string): Promise<{ ok: boolean }> {
    return deleteMaterialApi(id)
  },
}

export type {
  Material,
  MaterialInput,
  MaterialKind,
  MaterialStatus,
} from './types'
export { MATERIAL_KIND_LABEL, MATERIAL_STATUS_LABEL } from './types'
export {
  createMaterialApi,
  patchMaterialApi,
  deleteMaterialApi,
  archiveMaterialApi,
  restoreMaterialApi,
  getMaterialApi,
  listMaterialsApi,
  MaterialsApiClientError,
} from './apiClient'

